import { motion } from "framer-motion";


function Card({ img, altText, mainHeading, subHeading, bulletPoints }) {
    
  return (
    <div className=" w-full rounded-lg overflow-hidden shadow-lg border bg-[#f3ebfa]">
      <div className=" px-8  lg:px-10  pt-4 lg:pt-8 flex justify-center h-32 bg-white py-5 ">
        <img
          src={img}
          alt={altText}
          loading="lazy"
          className="h-full object-contain"
        />
      </div>
      <div className=" px-6 py-3 md:py-6">
        <div className="">
          <h3 className="text-[20px] md:text-[20px] leading-[1.2] text-dark font-bold mb-3 ">
            {mainHeading}: {subHeading}
          </h3>
          <ul className="list-inside list-disc pl-2 space-y-3">
            {bulletPoints.map((content,i) => (
              <li key={i} className="text-base leading-[1.625rem]">
                <span className="text-lg font-bold"> {content.boldText}: </span>{" "}
                {content.lightText}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
export default Card;